import { loadScript } from './feishu-sdk';

export const FEISHU_QR_SDK_URL =
  'https://lf-package-cn.feishucdn.com/obj/feishu-static/lark/passport/qrcode/LarkSSOSDKWebQRCode-1.0.3.js';

export const loadFeishuQrSdk = (targetDocument = document) =>
  loadScript(FEISHU_QR_SDK_URL, targetDocument);

export const buildFeishuQrRedirectUrl = (goto, tmpCode) => {
  const url = new URL(goto);
  url.searchParams.set('tmp_code', tmpCode);
  return url.toString();
};

export const buildFeishuQrAuthorizeUrl = (goto) => {
  const url = new URL(goto);
  url.searchParams.delete('scope');
  return url.toString();
};

export const resolveFeishuQrSdk = (targetWindow = window) => {
  if (typeof targetWindow?.LarkSSOSDKWebQRCode === 'function') {
    return targetWindow.LarkSSOSDKWebQRCode;
  }
  if (typeof targetWindow?.QRLogin === 'function') {
    return targetWindow.QRLogin;
  }
  return undefined;
};

export const createFeishuQrLogin = ({ qrSdk, containerId, goto }) => {
  if (typeof qrSdk !== 'function') {
    throw new Error('飞书扫码登录组件加载失败');
  }
  return qrSdk({
    id: containerId,
    goto,
    width: '250',
    height: '250',
    style: 'border: 0; background: #fff;',
  });
};

export const handleFeishuQrMessage = ({ assign, event, goto, qrLogin }) => {
  if (!qrLogin?.matchOrigin?.(event.origin) || !qrLogin?.matchData?.(event.data)) {
    return false;
  }
  const tmpCode = event.data?.tmp_code;
  if (!tmpCode) {
    return false;
  }
  assign(buildFeishuQrRedirectUrl(goto, tmpCode));
  return true;
};
